<template>
    <div class="bot-form-cent">
        <div class="bot-cent" v-for="box in 2" :key="box">
            <div class="bot-cent-tb red"
                 @click="setDellPrice(nowDetail.limitUpValue)"
                 v-if="box === 1">
                <div class="bot-cent-t">涨停:</div>
                <div class="bot-cent-t">{{nowDetail.limitUpValue}}</div>
                <div class="bot-cent-t">--</div>
            </div>
            <div class="bot-cent-tb"
                 @click="setDellPrice(getPri(box, item))"
                 v-for="item in dangci[box - 1]" :key="item">
                <div class="bot-cent-t">{{box === 1 ? '卖':'买'}}{{item}}</div>
                <div class="bot-cent-t"
                     :class="getColor(box, item)">{{getPri(box, item)}}</div>
                <div class="bot-cent-t">{{nowDetail[(box === 1 ? 'sell':'buy') + enNum[item - 1]]}}</div>
            </div>
            <div class="bot-cent-tb green"
                 @click="setDellPrice(nowDetail.limitDownValue)"
                 v-if="box === 2">
                <div class="bot-cent-t">跌停:</div>
                <div class="bot-cent-t">{{nowDetail.limitDownValue}}</div>
                <div class="bot-cent-t">--</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseFooterPriceGrade",
        data: function () {
            return {
                enNum: ['One', 'Two', 'Three', 'Four', 'Five'],
                dangci: [[5, 4, 3, 2, 1], 5],
                nbox: null,
                nitem: null
            }
        },
        computed: {
            nowDetail: function () {
                return this.$store.state.now_chois_gp_item || {
                    buyFive: '-',
                    buyFivePri: '-',
                    buyFour: '-',
                    buyFourPri: '-',
                    buyOne: '-',
                    buyOnePri: '-',
                    buyThree: '-',
                    buyThreePri: '-',
                    buyTwo: '-',
                    buyTwoPri: '-',
                    sellFive: '-',
                    sellFivePri: '-',
                    sellFour: '-',
                    sellFourPri: '-',
                    sellOne: '-',
                    sellOnePri: '-',
                    sellThree: '-',
                    sellThreePri: '-',
                    sellTwo: '-',
                    sellTwoPri: '-'
                }
            }
        },
        methods: {
            setDellPrice(price) {
                this.$emit('setPrice', price);
            },
            getPri(box, item) {
                return this.nowDetail[(box === 1 ? 'sell':'buy') + this.enNum[item - 1] + 'Pri']
            },
            getColor(box, item) {
                return {
                    'red': this.getPri(box, item) > this.nowDetail.preClose,
                    'green': this.getPri(box, item) < this.nowDetail.preClose,
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .bot-cent {
        .bot-cent-tb {
            cursor: pointer;
        }

        .bot-cent-tb:hover {
            background: #000000;
        }
    }
</style>
